export var CountryGroupType;
(function (CountryGroupType) {
    CountryGroupType[CountryGroupType["Roaming"] = 0] = "Roaming";
    CountryGroupType[CountryGroupType["IDD"] = 1] = "IDD";
})(CountryGroupType || (CountryGroupType = {}));
